"use strict";
// Copyright (c) StrangeBee 2023
Object.defineProperty(exports, "__esModule", { value: true });
const __1 = require("..");
class AttachmentController extends __1.ParentController {
    constructor() {
        super(...arguments);
        this.endpoints = {
            create: '/v1/attachment',
            get: '/v1/attachment/:attachmentId',
            download: '/v1/attachment/:attachmentId/download',
            delete: '/v1/attachment/:objectId',
        };
    }
    getAttachment(attachmentId) {
        return this.manager.get({ url: this.endpoints.get, params: { attachmentId } });
    }
    downloadAttachment(attachmentId) {
        return this.manager.get({ url: this.endpoints.download, params: { attachmentId } }, { responseType: 'arraybuffer' });
    }
}
exports.default = AttachmentController;
